import {dateFromStr, formatDate} from "../../common/time/TimeCalculator";
import {TimeScaleEnum} from "../../common/enum/enum";
import * as $ from "jquery";
import {PrecipitationChart} from "./PrecipitationChart";

/**
 * A special case of precipitation chart, with accumulated data
 * @extends PrecipitationChart
 * @hideconstructor
 */
class RainChart extends PrecipitationChart {

    getClassName() {
        return "RainChart";
    }

    _extractChartData() {
        const valsForProcessor = {values: {}, stats: {}};
        const values = this.dataFromService.features[0].properties.rain.values;
        if(!values)
            return valsForProcessor;
        const stats = this.dataFromService.features[0].properties.rain.stats;
        const timeScale = TimeScaleEnum._1.getCode();
        Object.keys(values).forEach(dateStr => {
            const value = values[dateStr] ? values[dateStr].backlog : undefined;
            const month = dateStr.split("-")[1];
            const avg = stats ? stats.avg[month][timeScale] : undefined;
            const std = stats ? stats.std[month][timeScale] : undefined;
            const date = dateFromStr(dateStr);
            valsForProcessor.values[formatDate(date)] = value[timeScale] ? value[timeScale] : null;
            valsForProcessor.stats[formatDate(date)] = {
                avg: avg !== undefined ? avg : null,
                std: std !== undefined ? std : null
            };
        });
        return valsForProcessor;
    }

    getContainerElement() {
        const containerElement = super.getContainerElement();
        const valuesChartContainer = $('.body .chart-container', containerElement);
        valuesChartContainer.addClass('values');
        $('<div class="chart-container accumulated"></div>').insertAfter(valuesChartContainer);
        return containerElement;
    }
}

export {RainChart}